<template>
  <div>
    <a class="text-blueGray-500 block" href="#pablo" ref="btnDropdownRef" v-on:click="toggleDropdown($event)">
      <div class="items-center flex">
        <span class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
          <img class="w-full h-full inline-flex rounded-full justify-center align-middle border-none shadow-lg"
            :src="cookie_arr.t_perid" style="object-fit: cover;object-position: top center;" />
        </span>
      </div>
    </a>
    <div ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48" v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }">
      <a href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
        {{ cookie_arr.t_name }} {{ cookie_arr.t_sname }}
      </a>
      <a href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
        ประเภท: {{ cookie_arr.t_permiss }}
      </a>
      <div class="h-0 my-2 border border-solid border-blueGray-100" />
      <a href="https://medstudent.medicine.psu.ac.th/ems" target="_blank"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
        <i class="fa fa-reply mr-2"></i>Back to EDIS
      </a>
      <a href="https://medstudent.medicine.psu.ac.th/ems/api/logout.php" target="_blank"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
        <i class="fa fa-power-off mr-2"></i>Logout
      </a>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

// import image from "@/assets/img/user.png";

import api from './../../services/student_services';

export default {
  data() {
    return {
      dropdownPopoverShow: false,
      // image: image,
      cookie_arr: []
    };
  },
  methods: {
    async access_token() {
      api.access_token().then(async (result) => {
        this.cookie_arr = result.data;
        if (this.cookie_arr.t_permiss === '-') {
          window.location.href = "https://edis.medicine.psu.ac.th";           
          // เปิดเว็บในหน้าต่างใหม่
        }
      });
    },
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
  },
  created: async function () {
    await this.access_token()
  },
};
</script>
